<form [formGroup]="projectForm" (ngSubmit)="updateOrCreateProject()">
  <mat-dialog-content>
    <div>
      @if (!data.id) {
        <h4>Neues Projekt anlegen</h4>
      }
      @if (data.id) {
        <h4>Projekt {{ data.name }} editieren</h4>
      }
      <mat-divider></mat-divider>

      <div>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" required />
          <mat-hint class="mat-caption" style="color: rgba(0, 0, 0, 0.6)">
            Kann nur über die API geändert werden
          </mat-hint>
          @if (projectForm.controls.name.hasError('required')) {
            <mat-error>
              Name des Projektes angeben
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Beschreibung</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Auftraggeber</mat-label>
          <mat-select formControlName="client" required>
            @for (client of availableClients; track client) {
              <mat-option
                matInput
                [value]="client.id"
                >{{ client.name }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>

          <mat-label>Ausgewählte Benutzer</mat-label>
          <div class="user-selection-group">
            <ng-container formArrayName="users">
              @for (user of availableUsers; track user; let i = $index) {
                <div>
                  <mat-checkbox [formControlName]="i">
                    {{ user.email }}
                  </mat-checkbox>
                </div>
              }
            </ng-container>
          </div>
          @if (projectForm.controls.users.hasError('requiresAtLeastOneUser')) {
            <mat-error
              >
              Mindestens einen Benutzer angeben
            </mat-error>
          }

          <mat-form-field>
            <mat-label>Transformation</mat-label>
            <mat-select formControlName="transformationFrom" required>
              @for (transformation of availableTransformations; track transformation) {
                <mat-option
                  matInput
                  [value]="transformation.key"
                  >{{ transformation.value }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>

            <div class="active-setting">
              <div class="flex flex-row">
                <span class="pr-4"> Projekt aktiv:</span>
                <mat-checkbox formControlName="active"> </mat-checkbox>
              </div>
            </div>

            <!-- <mat-form-field>
            <mat-label>Transformation zu</mat-label>
            <mat-select formControlName="transformationTo" required>
              <mat-option
                matInput
                *ngFor="let transformation of availableTransformations"
                [value]="transformation.key"
                >{{ transformation.value }}</mat-option
                >
              </mat-select>
            </mat-form-field> -->
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!projectForm.valid"
          >
          @if (!data.id) {
            Projekt anlegen
          }
          @if (data.id) {
            Speichern
          }
        </button>
        <!-- Buttons are disabled to avoid confusion when re-creating projects -->
        <!-- <button mat-raised-button *ngIf="data.id" (click)="deleteProject($event)">
        {{ data.name }} löschen
      </button> -->
      <button mat-raised-button [mat-dialog-close]="true">Schließen</button>
    </mat-dialog-actions>
  </form>
